import React from 'react';

import {AppBar, Toolbar, Typography, IconButton, makeStyles, Box} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
}));

const ReportNavbar = ({ setOpenDrawer, reportTitle ,history }) => {
    const classes = useStyles();

    const handleBackNavigation = () => {
        history.goBack();
        // if (reportTitle === 'Dashboard')
        //     history.push('/');
        // else if (reportTitle === 'Devices Information')
        //     history.push('/admin/users');
        // else if (reportTitle === 'Connections')
        //     history.goBack();
        // else
        //     history.push('/dashboard');
    };

    return (
        <AppBar position="fixed" className={classes.appBarReport} elevation={0} color="inherit">
            <Toolbar className={classes.toolbar}>
                <Box className={classes.sideIcons}>
                    <IconButton
                        edge="start"
                        className={classes.backButton}
                        onClick={handleBackNavigation}
                        disableRipple>
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                <Typography variant="h6" noWrap className={classes.reportTitleText} >
                    {reportTitle}
                </Typography>
                <Box className={classes.sideIcons} style={{ justifyContent: 'flex-end' }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        className={classes.menuButton}
                        onClick={() => setOpenDrawer(true)}>
                        <MenuIcon />
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default React.memo(ReportNavbar);
